(() => {
  'use strict';
  if (!document.body.classList.contains('pt-accessory-pdp') || window.__ptAccessoryMasterAdapter) return;
  window.__ptAccessoryMasterAdapter = true;

  const normalize = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const removeLegacyFaq = () => {
    Array.from(document.querySelectorAll('h2')).forEach((heading) => {
      if (normalize(heading.textContent) !== 'Häufige Fragen zu diesem Produkt') return;
      if (heading.closest('.pt-accessory-faq, .pt-tea-faq')) return;

      const stack = heading.closest('.section-stack.section-stack--center');
      const wrapper = stack?.parentElement || heading.closest('div');
      if (!wrapper) return;

      const next = wrapper.nextElementSibling;
      if (next?.matches('script[type="application/ld+json"]') && /"FAQPage"/.test(next.textContent || '')) next.remove();
      wrapper.remove();
    });
  };

  const removeLegacyConversionArtifacts = () => {
    document.querySelectorAll('[data-paratito-pdp-story],[data-paratito-pdp-seo]').forEach((node) => {
      if (!node.closest('.shopify-section--accessory-seo')) node.remove();
    });
  };

  const removeLegacyProductGuide = () => {
    document.querySelectorAll('.paratito-product-guide-mount').forEach((node) => node.remove());
  };

  const updateStickyTitle = () => {
    const title = document.querySelector('.pt-accessory-buybox-heading h1')?.textContent?.trim();
    if (!title) return;
    document.querySelectorAll('product-quick-add .bold.truncate-text').forEach((node) => {
      node.textContent = title;
    });
  };

  const setAvailability = (available) => {
    if (typeof available !== 'boolean') return;
    const node = document.querySelector('[data-pt-accessory-availability]');
    if (!node) return;

    node.classList.toggle('is-unavailable', !available);
    const title = node.querySelector('strong');
    const detail = title?.nextElementSibling;
    if (title) title.textContent = available ? 'Verfügbar' : 'Aktuell nicht verfügbar';
    if (detail) detail.textContent = available ? 'Versand in 1 bis 3 Werktagen' : 'Dieser Artikel ist aktuell nicht verfügbar';
  };

  const getVariant = (event) => event?.detail?.variant || event?.detail?.productVariant || null;

  const boot = () => {
    removeLegacyFaq();
    removeLegacyConversionArtifacts();
    removeLegacyProductGuide();
    updateStickyTitle();
    window.setTimeout(removeLegacyFaq, 150);
    window.setTimeout(removeLegacyFaq, 700);
    window.setTimeout(updateStickyTitle, 150);
  };

  document.addEventListener('variant:change', (event) => {
    const variant = getVariant(event);
    if (variant) {
      if (typeof variant.available === 'boolean') setAvailability(variant.available);
      else if (typeof variant.availableForSale === 'boolean') setAvailability(variant.availableForSale);
    }
    requestAnimationFrame(updateStickyTitle);
  });

  document.addEventListener('shopify:section:load', () => requestAnimationFrame(boot));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
